module.exports = __webpack_public_path__ + "static/media/do-not-disturb.1ec621ef.svg";